module.exports = __webpack_public_path__ + "static/the-badass-librarians-of-timbuktu-aea00c1fd58edbcc1d73b12943a131c5.jpg";